const FREQ_COOKIE = 'brillyant_email_popup_dismissed';
const PENDING_KEY = 'brillyant_popup_pending';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1') + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
}

function shouldShow(popup) {
  if (popup.dataset.designMode === 'true') return true;
  return !getCookie(FREQ_COOKIE);
}

function markFrequencyDismissed(popup) {
  if (popup.dataset.designMode === 'true') return;
  const days = parseInt(popup.dataset.frequencyDays, 10);
  if (Number.isFinite(days) && days > 0) {
    setCookie(FREQ_COOKIE, '1', days);
  }
}

function isDesignMode(popup) {
  return popup.dataset.designMode === 'true' || (window.Shopify && window.Shopify.designMode);
}

function bindCopyToClipboard(popup) {
  const codeButton = popup.querySelector('[data-discount-code]');
  if (!codeButton) return;
  codeButton.addEventListener('click', async () => {
    const code = codeButton.dataset.discountCode;
    const hint = codeButton.querySelector('[data-copy-hint]');
    try {
      await navigator.clipboard.writeText(code);
      if (hint) {
        const original = hint.textContent;
        hint.textContent = 'Kopiert!';
        setTimeout(() => {
          hint.textContent = original;
        }, 1800);
      }
    } catch (e) {
      const valueEl = codeButton.querySelector('.email-popup__code-value');
      if (valueEl) {
        const range = document.createRange();
        range.selectNodeContents(valueEl);
        const sel = window.getSelection();
        sel?.removeAllRanges();
        sel?.addRange(range);
      }
    }
  });
}

/** Erfolgszustand anzeigen: Formular ausblenden, Bestätigung/Code zeigen. */
function showSuccessState(popup) {
  const wrapper = popup.querySelector('[data-popup-form]');
  if (!wrapper) return;
  const form = wrapper.querySelector('form');
  const successBox = wrapper.querySelector('[data-popup-success]');

  if (form) form.hidden = true;
  markFrequencyDismissed(popup);
  if (successBox) successBox.hidden = false;
}

function showErrorState(popup) {
  const wrapper = popup.querySelector('[data-popup-form]');
  const errorBox = wrapper?.querySelector('[data-popup-error]');
  const submitBtn = wrapper?.querySelector('[type="submit"]');
  if (submitBtn) submitBtn.disabled = false;
  if (errorBox) {
    errorBox.hidden = false;
    errorBox.focus?.();
  }
}

/**
 * Behandelt die Rückkehr nach einem nativen Formular-Submit.
 * @returns {boolean} true, wenn ein Popup-Submit verarbeitet wurde.
 */
function handleSubmitReturn(popup) {
  let pending = null;
  try {
    pending = sessionStorage.getItem(PENDING_KEY);
  } catch (e) {
    return false;
  }
  if (!pending) return false;

  // Marker konsumieren (egal wie es ausgeht)
  try {
    sessionStorage.removeItem(PENDING_KEY);
  } catch (e) {
    /* ignore */
  }

  const params = new URLSearchParams(window.location.search);
  const success = params.get('customer_posted') === 'true' || params.get('contact_posted') === 'true';

  if (success) {
    showSuccessState(popup);
  } else {
    // Submit ging an Shopify, kam aber ohne Erfolgsparameter zurück → Fehler
    showErrorState(popup);
  }

  // Popup nach dem Reload wieder öffnen, damit der Nutzer das Ergebnis sieht
  requestAnimationFrame(() => popup.showDialog?.());
  return true;
}

function bindForm(popup) {
  const wrapper = popup.querySelector('[data-popup-form]');
  if (!wrapper) return;
  const form = wrapper.querySelector('form');
  if (!form) return;
  const errorBox = wrapper.querySelector('[data-popup-error]');
  const submitBtn = form.querySelector('[type="submit"]');

  form.addEventListener('submit', (event) => {
    if (errorBox) errorBox.hidden = true;

    // Im Theme-Editor werden Formulare nicht echt verarbeitet → Erfolg simulieren
    if (isDesignMode(popup)) {
      event.preventDefault();
      showSuccessState(popup);
      return;
    }

    // Echter Shop: nativen Submit zulassen (Shopify macht POST + Redirect).
    // Marker setzen, damit wir nach dem Reload wissen, dass dieser Post vom Popup kam.
    try {
      sessionStorage.setItem(PENDING_KEY, '1');
    } catch (e) {
      /* ignore */
    }
    if (submitBtn) submitBtn.disabled = true;
    // KEIN preventDefault → das Formular wird normal abgeschickt.
  });
}

function init(popup) {
  if (!popup) return;

  bindCopyToClipboard(popup);
  bindForm(popup);

  // Kommen wir gerade von einem Popup-Submit zurück? Dann Ergebnis zeigen.
  if (handleSubmitReturn(popup)) return;

  if (!shouldShow(popup)) return;

  const delay = Math.max(0, parseInt(popup.dataset.delay, 10) || 0) * 1000;

  const open = () => {
    if (document.visibilityState !== 'visible') {
      document.addEventListener('visibilitychange', open, { once: true });
      return;
    }
    popup.showDialog?.();
  };

  if (delay === 0) {
    open();
  } else {
    setTimeout(open, delay);
  }

  popup.addEventListener('dialog:close', () => markFrequencyDismissed(popup));
}

function boot() {
  document.querySelectorAll('dialog-component.email-popup').forEach((popup) => {
    if (popup.hasAttribute('data-popup-initialised')) return;
    popup.setAttribute('data-popup-initialised', '');

    // Warten bis die dialog-component definiert & verbunden ist,
    // damit showDialog()/refs garantiert verfügbar sind.
    const ready = customElements.whenDefined('dialog-component');
    ready.then(() => requestAnimationFrame(() => init(popup)));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

document.addEventListener('shopify:section:load', boot);
